if (!customElements.get('subscription-popup')) {
  customElements.define(
    'subscription-popup',
    class SubscriptionPopup extends DrawerComponent {
      static get observedAttributes() {
        return super.observedAttributes.concat(['data-trigger-open', 'data-repeat-open']);
      }

      constructor() {
        super();
      }

      get requiresBodyAppended() {
        return false;
      }

      get toggleButton() {
        return this.controls.find((control) => control.classList.contains('subscription-popup__teaser'));
      }

      connectedCallback() {
        super.connectedCallback();

        this.triggerOpen = this.dataset.triggerOpen;
        this.repeatOpen = this.dataset.repeatOpen;
        this.cookieName = 'hypertheme:popup';
        this.teaserCookieName = 'hypertheme:popup-teaser';

        if (this.toggleButton) {
          this.toggleTeaser(this.toggleButton, false, 0);
        }

        window.FoxTheme.DOMready(this.handleOpen.bind(this));
      }

      prepareToShow() {
        super.prepareToShow();
        this.setRepeatOpen();
      }

      onButtonClick(event) {
        event.preventDefault();

        if (event.target.hasAttribute('data-close-teaser')) {
          this.toggleTeaser(this.toggleButton, true);
          return;
        }

        super.onButtonClick(event);
      }

      handleOpen() {
        if (Shopify.designMode) return;

        let savedData = FoxTheme.utils.getStorage(this.cookieName);
        if (savedData && savedData.opened) {
          return false;
        }

        switch (this.triggerOpen) {
          case 'delay':
            setTimeout(() => {
              this.show();
            }, 5000);
            break;
          case 'scroll_down':
            this.triggerAfterScroll(700, this.show.bind(this));
            break;
          default:
            this.show();
            break;
        }
      }

      triggerAfterScroll(offset = 500, trigger) {
        let opened = false;
        const start = 0;
        window.addEventListener('scroll', (e) => {
          let scrollTop =
            window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;

          if (scrollTop - start > offset && !opened) {
            trigger();
            opened = true;
            return;
          }
        });
      }

      setRepeatOpen() {
        if (Shopify.designMode) return;

        let expires;
        switch (this.repeatOpen) {
          case 'no_repeat':
            expires = 365;
            break;
          case 'every_3_mins':
            expires = 3 / 60 / 24;
            break;
          case 'every_5_mins':
            expires = 5 / 60 / 24;
            break;
          case 'every_10_mins':
            expires = 1 / 6 / 24;
            break;
          case 'every_15_mins':
            expires = 15 / 60 / 24;
            break;
          case 'every_30_mins':
            expires = 1 / 2 / 24;
            break;
          case 'every_1_hr':
            expires = 1 / 24;
            break;
          case 'every_6_hrs':
            expires = 6 / 24;
            break;
          case 'every_12_hrs':
            expires = 1 / 2;
            break;
          case 'every_day':
            expires = 1;
            break;
          case 'every_3_days':
            expires = 3;
            break;
          case 'every_week':
            expires = 7;
            break;
          case 'every_2_weeks':
            expires = 14;
            break;
          case 'every_month':
            expires = 30;
            break;
          default:
            expires = 7;
            break;
        }

        window.FoxTheme.utils.setStorage(this.cookieName, { opened: true }, expires);
      }

      toggleTeaser(toggleEl, shouldHide, hideDurationHours = 4) {
        if (!toggleEl) return;

        const currentTime = new Date().getTime();
        const hideDuration = hideDurationHours * 60 * 60 * 1000;

        if (shouldHide) {
          toggleEl.classList.add('hidden');
          toggleEl.hidden = true;
          toggleEl.setAttribute('aria-hidden', 'true');
          window.FoxTheme.utils.setStorage(
            this.teaserCookieName,
            {
              hidden: true,
              hiddenAt: currentTime,
              hideDuration,
            },
            hideDurationHours / 24
          );
          return;
        }

        const teaserState = window.FoxTheme.utils.getStorage(this.teaserCookieName);

        if (teaserState && teaserState.hiddenAt) {
          const timeElapsed = currentTime - parseInt(teaserState.hiddenAt, 10);

          if (timeElapsed < parseInt(teaserState.hideDuration, 10)) {
            toggleEl.classList.add('hidden');
            toggleEl.hidden = true;
            toggleEl.setAttribute('aria-hidden', 'true');
            return;
          }

          window.localStorage.removeItem(this.teaserCookieName);
        }

        toggleEl.classList.remove('hidden');
        toggleEl.hidden = false;
        toggleEl.removeAttribute('aria-hidden');
      }
    }
  );
}
